import { Grid, Heading, Layout } from '@enterprise-ui/canvas-ui-react'

export const SectionHeader = ({ className, pageHeading, subtext, style }) => {
  return (
    <Layout.SectionHeader className={className} style={style}>
      <div className="hesp-section-header hc-pa-dense hc-pb-none">
        <Grid.Container spacing="dense">
          {pageHeading && (
            <Grid.Item style={{ width: '100%', padding: '0px' }}>
              <Heading data-testid="sectionHeaderHeading" size={2}>
                {pageHeading}
              </Heading>
              {subtext && <span className="hc-fs-sm">{subtext}</span>}
            </Grid.Item>
          )}
        </Grid.Container>
      </div>
    </Layout.SectionHeader>
  )
}
